/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal__header[_ngcontent-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end}.modal__title[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;font-size:22px;padding:.5em 0 1em}.modal__terms[_ngcontent-%COMP%]{margin-right:2em;text-align:justify}.modal__terms[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1em}.modal__action[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;margin:2em 0 1em}"];
export { styles as styles };
